export const MAX_CASES_COUNT = 6;
export const MAX_MULTIPLE_COUNT = 10;
